import { Directive, ElementRef, EventEmitter, HostListener, inject, Output } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[lnClickOutSide]',
})
export class ClickOutSideDirective {
  @Output() clickOutside = new EventEmitter<void>();
  @Output() mouseLeave = new EventEmitter<void>();
  private elementRef = inject(ElementRef);

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.clickOutside.emit();
    }
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.mouseLeave.emit();
  }
}
